import styled from "styled-components";

export const ACCENTS = {
  orange: "#f59e0b",
  violet: "#8b5cf6",
  emerald: "#10b981",
  sky: "#0ea5e9",
  indigo: "#6366f1",
  zinc: "#71717a",
} as const;

export const Card = styled.div<{ $accent }>`
  --accent: ${({ $accent }) => ($accent ? ACCENTS[$accent] : ACCENTS.zinc)};

  background: linear-gradient(
        90deg,
        color-mix(in srgb, var(--accent), #ffffff 30%) 0%,
        var(--accent) 18%,
        var(--accent) 82%,
        color-mix(in srgb, var(--accent), #ffffff 30%) 100%
      )
      top / 100% 3px no-repeat,
    #ffffff;

  border: 1px solid #e5e7eb;
  border-top-color: transparent;
  border-radius: 14px;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.06);
  overflow: hidden;

  padding: 16px;
  display: grid;
  place-items: center;

  transition: border-color 0.15s ease, box-shadow 0.15s ease,
    transform 0.12s ease;

  &:hover {
    transform: translateY(-1px);
    border-color: #cbd5e1;
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
  }

  &:focus-within {
    outline: 2px solid color-mix(in srgb, var(--accent), #000 15%);
    outline-offset: 2px;
  }

  .CircularProgressbar {
    width: 160px;
    height: 160px;
  }
`;

export const ValueRow = styled.div`
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  margin-top: 8px;
`;

export const Value = styled.span`
  font-size: 26px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1;
`;

export const Label = styled.div`
  margin-top: 8px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
`;
